module.exports = __webpack_public_path__ + "img/globo-terraqueo.80b26f4e.png";